export default __webpack_public_path__ + "static/media/modernV2.2be1091c.png";